module.exports = __webpack_public_path__ + "img/edge-icon.9201cc93.png";